export class TeamMemberForDataExport_v1 {
    id: number;
    role: number;
    shareType: number;
}